import React, { useContext } from 'react';
import pt from 'prop-types';
import { RootContext } from 'components/storefront/editor/easyblocks-page/components/root';

const SECTION_GROUP_ID_REGEX = /^swell-section-group__(.+)$/;

function getSectionClassName(theme, component, groupId) {
  const sectionClassName = theme.getSectionClassName();
  const sectionIdPrefix = theme.getSectionIdPrefix();

  return `${sectionClassName} ${sectionIdPrefix}-group-${groupId} section-${component}`;
}

function SectionGroup(props) {
  const { id } = props;
  const rootProps = useContext(RootContext);

  const match = id?.match(SECTION_GROUP_ID_REGEX);

  if (!match) {
    return null;
  }

  const [, sectionGroupId] = match;
  const groupSections = rootProps[`SectionGroup_${sectionGroupId}`];

  if (!Array.isArray(groupSections)) {
    return null;
  }

  return groupSections.map((Section) => {
    const { _id: id, _component: component } = Section.props.compiled;
    const sectionClassName = getSectionClassName(
      rootProps.theme,
      component,
      sectionGroupId,
    );

    const SectionComponent = Section.type;

    return (
      <SectionComponent
        {...Section.props}
        key={id}
        className={sectionClassName}
      />
    );
  });
}

SectionGroup.propTypes = {
  id: pt.string,
  children: pt.oneOfType([pt.element, pt.array]),
};

export default React.memo(SectionGroup);
